declare var $: any;
declare var TagsInput: any;

export const boxForm = function () {
	let inpGroups = document.querySelectorAll(".box-form .form-group");

	inpGroups.forEach(function (item) {
		let eyeHide = <HTMLElement>item.querySelector(".eye-hide");
		let eyeShow = <HTMLElement>item.querySelector(".eye-show");

		if (eyeHide && eyeShow) {
			let inpItem = item.querySelector("input");

			eyeHide.onclick = function () {
				item.classList.add("show");
				inpItem.setAttribute("type", "text");
			};
			eyeShow.onclick = function () {
				item.classList.remove("show");
				inpItem.setAttribute("type", "password");
			};
		}
	});

	$(".tag-select").select2({
		tags: true,
    	tokenSeparators: [',', ' ']
	});

	// source: https://codepen.io/wallaceerick/pen/nJLPvN

	// $("select").each(function () {
	// 	let cur = <HTMLElement>this;
	// 	if (cur.parentElement.classList.contains('select')) {
	// 		var $this = $(this),
	// 			numberOfOptions = $(this).children("option").length;

	// 		var $parent = $this.parent();

	// 		var $styledSelect = $parent.find("div.select-styled");
	// 		$styledSelect.html($this.children("option").eq(0).text() + "");

	// 		var $list = $parent.find(".select-options");
	// 		$list.empty();
			
	// 		for (var i = 0; i < numberOfOptions; i++) {
	// 			if ($this.children("option").eq(i).is(":selected")) {
	// 				$("<li />", {
	// 					text: $this.children("option").eq(i).text(),
	// 					rel: $this.children("option").eq(i).val(),
	// 				})
	// 					.addClass("is-selected")
	// 					.appendTo($list);

	// 				$styledSelect.html(
	// 					$this.children("option").eq(i).text() + "",
	// 				);
	// 			} else {
	// 				$("<li />", {
	// 					text: $this.children("option").eq(i).text(),
	// 					rel: $this.children("option").eq(i).val(),
	// 				}).appendTo($list);
	// 			}
	// 		}

	// 		$styledSelect.click(function (e: any) {
	// 			e.stopPropagation();
	// 			$("div.select-styled.active")
	// 				.not(this)
	// 				.each(function () {
	// 					$(this)
	// 						.removeClass("active")
	// 						.next("ul.select-options")
	// 						.hide();
	// 				});
	// 			$(this)
	// 				.toggleClass("active")
	// 				.next("ul.select-options")
	// 				.toggle();
	// 		});

	// 		$list.children("li").click(function (e: any) {
	// 			e.stopPropagation();
	// 			$list.children("li").removeClass("is-selected");
	// 			$(this).addClass("is-selected");

	// 			$styledSelect.html($(this).text() + "");
	// 			$this.val($(this).attr("rel"));
	// 			$list.hide();
	// 		});

	// 		$(document).click(function () {
	// 			$styledSelect.removeClass("active");
	// 			$list.hide();
	// 		});

	// 	} else {
	// 		var $this = $(this),
	// 			numberOfOptions = $(this).children("option").length;

	// 		$this.addClass("select-hidden");
	// 		$this.wrap('<div class="select"></div>');
	// 		$this.after('<div class="select-styled"></div>');

	// 		var $styledSelect = $this.next("div.select-styled");
	// 		$styledSelect.html($this.children("option").eq(0).text() + "");

	// 		var $icon = $(
	// 			'<svg class="icon" width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L3 3L5 1" stroke="black" stroke-linecap="round"/></svg>',
	// 			{
	// 				class: "icon",
	// 			},
	// 		).insertAfter($styledSelect);

	// 		var $list = $("<ul />", {
	// 			class: "select-options",
	// 		}).insertAfter($styledSelect);

	// 		// for (var i = 0; i < numberOfOptions; i++) {
	// 		// 	let strLi = `<li rel="${$this.children("option").eq(i).val()}">${$this.children("option").eq(i).text()}</li>`;
	// 		// }

	// 		for (var i = 0; i < numberOfOptions; i++) {
	// 			if ($this.children("option").eq(i).is(":selected")) {
	// 				$("<li />", {
	// 					text: $this.children("option").eq(i).text(),
	// 					rel: $this.children("option").eq(i).val(),
	// 				})
	// 					.addClass("is-selected")
	// 					.appendTo($list);

	// 				$styledSelect.html(
	// 					$this.children("option").eq(i).text() + "",
	// 				);
	// 			} else {
	// 				$("<li />", {
	// 					text: $this.children("option").eq(i).text(),
	// 					rel: $this.children("option").eq(i).val(),
	// 				}).appendTo($list);
	// 			}
	// 		}

	// 		// 	if ($this.children("option").eq(i).is(":selected")) {
	// 		// 		$(
	// 		// 			'li[rel="' + $this.children("option").eq(i).val() + '"]',
	// 		// 		).addClass("is-selected");
	// 		// 	}
	// 		// }

	// 		// let listSelect = document.querySelectorAll('.select');
	// 		// let firstSelect = <HTMLElement>listSelect[0].querySelector('.select-options');
	// 		// console.log(firstSelect.innerHTML);

	// 		// var $listItems = $list.children("li");

	// 		$styledSelect.click(function (e: any) {
	// 			e.stopPropagation();
	// 			$("div.select-styled.active")
	// 				.not(this)
	// 				.each(function () {
	// 					$(this)
	// 						.removeClass("active")
	// 						.next("ul.select-options")
	// 						.hide();
	// 				});
	// 			$(this)
	// 				.toggleClass("active")
	// 				.next("ul.select-options")
	// 				.toggle();
	// 		});

	// 		// console.log($list.children('li'))
	// 		$list.children("li").click(function (e: any) {
	// 			e.stopPropagation();
	// 			$list.children("li").removeClass("is-selected");
	// 			$(this).addClass("is-selected");

	// 			$styledSelect.html($(this).text() + "");
	// 			$this.val($(this).attr("rel"));
	// 			$list.hide();
	// 		});

	// 		$(document).click(function () {
	// 			$styledSelect.removeClass("active");
	// 			$list.hide();
	// 		});
	// 	}
	// });

	// Lựa chọn cho form
	let boxForms = document.querySelectorAll(".box-form");
	boxForms.forEach(function (box) {
		let optForm = box.querySelector(".box-form-opt");
		let selForm = box.querySelectorAll(".box-form-sel");

		if (optForm && selForm) {
			let itemOpts = optForm.querySelectorAll(".opt-item");
			itemOpts.forEach(function (item: HTMLElement, idx, listItem) {
				item.onclick = function (e) {
					e.preventDefault();

					listItem.forEach(function (itemTemp) {
						itemTemp.classList.remove("active");
					});

					item.classList.add("active");

					selForm.forEach(function (selItem) {
						selItem.classList.remove("active");
					});

					selForm[idx].classList.add("active");
				};
			});
		}
	});

	// init id="tag-project"
	let tagInit1 = document.getElementById("tag-project");
	if (tagInit1) {
		var tagInput1 = new TagsInput({
			selector: "tag-project",
			duplicate: false,
			max: null,
		});
		// tagInput1.addData(["PHP", "JavaScript", "CSS"]);
	}

	// file upload
	let filesUpload = document.querySelectorAll(".upload-files");
	const arrayFile = new Array();

	filesUpload.forEach(function (fileUpload) {
		var fileItem = <HTMLInputElement>(
			fileUpload.querySelector('input[type="file"')
		);

		fileItem.addEventListener("change", function (e) {
			e.preventDefault();
			const filesInput = fileItem.files;

			for (let i = 0; i < filesInput.length; i++) {
				let file = filesInput[i];
				if (checkFileAccept(file)) {
					if (checkFileSize(file)) {
						load(file);
					} else {
						alert(`The file does not exceed 10 MB: ${file.name}`);
					}
				} else {
					alert(`The file is not an image: ${file.name}`);
				}
			}
		});
	});

	// read upload
	let rowsTable = document.querySelectorAll("#tableImages tbody tr");
	rowsTable.forEach(function (itemRow, idxRow) {
		// console.log(arrayFile);

		// let stt = <HTMLElement>itemRow.querySelector("td:nth-of-type(1)");
		let img = <HTMLElement>itemRow.querySelector("td:nth-of-type(2) img");

		// img.setAttribute('src', URL.createObjectURL(fileInfo));
		// url.innerText = URL.createObjectURL(fileInfo);
		// fileRoot.innerHTML = itemRow.innerHTML;

		let actRemove = <HTMLElement>itemRow.querySelector(".action-remove");
		actRemove.addEventListener("click", function (e) {
			e.preventDefault();
			removeFile(idxRow, itemRow);
		});

		const data = new FormData();

		const fileNew = new File(
			[img.getAttribute("name")],
			`${img.getAttribute("src")}`,
			{
				type: "images/*",
			},
		);

		arrayFile.push(fileNew);
	});

	// size file
	function checkFileSize(fileInfo: any) {
		const mbSize = 1024 * 1024;
		let size = fileInfo.size / mbSize;
		if (size > 10) {
			return false;
		}
		return true;
	}
	// accept file
	function checkFileAccept(fileInfo: any) {
		let type = fileInfo.type;

		if (type.split("/")[0] == "image") {
			return true;
		}
		return false;
	}

	function appendFile(fileId: any) {
		const newFile = `
				<td data-title="Progress" colspan="4">
					<div class="progress-bar"><span style="width:0%;"></span></div>
				</td>
			`;

		const trTable = document.createElement("tr");
		if (trTable) {
			trTable.setAttribute("id", fileId);
			trTable.classList.add("fileId");
			trTable.innerHTML = newFile;
			let tableImages = document.querySelector("#tableImages tbody");
			tableImages.append(trTable);
		} else {
			console.log("error createElement");
		}
	}

	function removeFile(elementId: any, fileRoot: any) {
		// remove element
		fileRoot.style.opacity = "0";
		setTimeout(function () {
			fileRoot.remove();

			// remove item array
			arrayFile.splice(elementId, 1);

			// change id in tag table tr
			let tableImages = document.querySelectorAll(
				"#tableImages tbody tr",
			);
			if (arrayFile.length === tableImages.length) {
				tableImages.forEach(function (item, idx) {
					const fileId = `file-${idx}`;
					item.setAttribute("id", fileId);
					item.classList.add("fileId");

					let stt = <HTMLElement>(
						item.querySelector("td:nth-of-type(1)")
					);
					stt.innerText = idx + 1 + "";
				});
			} else {
				console.log("error number file");
			}
		}, 300);
	}

	function changeInputUpload() {}

	function fileProgressing(
		elementId: any,
		idxElement: any,
		fileInfo: any,
		progressing: any,
	) {
		const fileRoot = document.querySelector(`${elementId}`);
		const progressFile = fileRoot.querySelector(".progress-bar");

		progressFile.querySelector("span").style.width = progressing + "%";

		if (progressing >= 100) {
			setTimeout(function () {
				const htmlExp = document.createElement("tr");
				htmlExp.innerHTML = `
					<td data-title="STT">1</td>
					<td data-title="Hình ảnh"><img src="./assets/images/project/harvest1.png" alt=""></td>
					<td data-title="URL">./assets/images/project/harvest1.png</td>
					<td class="actiion-td" data-title="Tác vụ"> 
						<button class="action action-remove" type="button">
							<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M8.64358 1.62149C8.83809 1.62149 9.00002 1.78299 9.00002 1.98849V2.17848C9.00002 2.37898 8.83809 2.54548 8.64358 2.54548H0.356928C0.16193 2.54548 0 2.37898 0 2.17848V1.98849C0 1.78299 0.16193 1.62149 0.356928 1.62149H1.81479C2.11093 1.62149 2.36866 1.41099 2.43528 1.11399L2.51162 0.772994C2.63028 0.308498 3.02076 0 3.46765 0H5.53238C5.97441 0 6.36926 0.308498 6.48354 0.748495L6.56523 1.11349C6.63137 1.41099 6.88909 1.62149 7.18572 1.62149H8.64358ZM7.90254 8.56699C8.05475 7.1485 8.32123 3.77852 8.32123 3.74452C8.33096 3.64153 8.2974 3.54403 8.23078 3.46553C8.1593 3.39203 8.06885 3.34853 7.96916 3.34853H1.03388C0.933702 3.34853 0.838392 3.39203 0.772258 3.46553C0.705152 3.54403 0.672085 3.64153 0.676948 3.74452C0.677841 3.75077 0.687403 3.86948 0.70339 4.06794C0.774406 4.94956 0.972199 7.40506 1.10001 8.56699C1.19046 9.42298 1.75211 9.96098 2.56565 9.98048C3.19343 9.99498 3.84018 9.99998 4.50152 9.99998C5.12444 9.99998 5.75709 9.99498 6.40432 9.98048C7.24607 9.96598 7.80723 9.43748 7.90254 8.56699Z" fill="white"></path>
							</svg>
						</button>
					</td>
					`;

				let stt = <HTMLElement>(
					htmlExp.querySelector("td:nth-of-type(1)")
				);
				let img = <HTMLElement>(
					htmlExp.querySelector("td:nth-of-type(2) img")
				);
				let url = <HTMLElement>(
					htmlExp.querySelector("td:nth-of-type(3)")
				);
				stt.innerText = idxElement + 1;

				img.setAttribute("src", URL.createObjectURL(fileInfo));
				url.innerText = URL.createObjectURL(fileInfo);
				fileRoot.innerHTML = htmlExp.innerHTML;

				let actRemove = <HTMLElement>(
					fileRoot.querySelector(".action-remove")
				);
				actRemove.addEventListener("click", function (e) {
					e.preventDefault();
					removeFile(elementId, fileRoot);
				});

				// add arrayFile
				// let dataFile = fileInfo;
				arrayFile.push(fileInfo);
				console.log(arrayFile);

				changeInputUpload();
			}, 300);
		}
	}

	function load(newFile: any) {
		// 1. Khởi tạo XHR để call API
		const xhr = new XMLHttpRequest();

		// 2. Thêm dữ liệu
		const data = new FormData();
		data.append("file", newFile);

		console.log(document.querySelector("#tableImages tbody"));
		// 3. Tạo id cho file và thêm nó vào giao diện
		const randomId = document.querySelector("#tableImages tbody")
			.childElementCount;
		const elementId = `file-${randomId}`;
		appendFile(elementId);

		// 4. Giả lập phương thức đăng tệp
		xhr.open("POST", "/upload", true);

		// 5. Lắng nghe sự kiện progress lấy tỉ lệ %
		xhr.upload.addEventListener("progress", function (event) {
			const percent = Math.round((event.loaded / event.total) * 100);
			fileProgressing(`#${elementId}`, randomId, newFile, percent);
		});

		// 6. Gửi yêu cầu
		xhr.send(data);
	}
};
